(function () {
  const FORM_SELECTOR = '[data-drye-atc-form]';

  function handleSubmit(e) {
    const form = e.target.closest(FORM_SELECTOR);
    if (!form) return; // inte vår form

    e.preventDefault();

    // säkerställ att variant är vald
    const variantInput = form.querySelector('input[name="id"], select[name="id"]');
    if (!variantInput || !variantInput.value) {
      console.warn('[DRYE ATC] No variant selected');
      return;
    }

    const submitBtn   = form.querySelector('[data-atc], .atcButton, button[type="submit"]');
    const originalTxt = submitBtn ? submitBtn.textContent : null;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
    }

const fd = new FormData(form);

function addToCart(fd) {
  return fetch('/cart/add.js', {
    method: 'POST',
    body: fd,
    headers: { 'Accept': 'application/json' },
    credentials: 'same-origin'
  }).then(function(res){
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  });
}

addToCart(fd)
  .catch(function(){
    // retry en gång efter 400ms
    return new Promise(function(resolve){
      setTimeout(resolve, 400);
    }).then(function(){
      return addToCart(fd);
    });
  })
  .then(function(){
    if (window.DRYE_CartDrawer && typeof window.DRYE_CartDrawer.refresh === 'function') {
      return window.DRYE_CartDrawer.refresh(true);
    }

    if (window.DRYE_CartDrawer && typeof window.DRYE_CartDrawer.open === 'function') {
      window.DRYE_CartDrawer.open();
      return;
    }

    // drawer saknas → fallback
    window.location.href = '/checkout';
  })
  .catch(function(err){
    console.error('[DRYE ATC] final error', err);
    window.location.href = '/checkout';
  })
  .finally(function () {
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = originalTxt || 'Add to cart';
    }
  });
  }

  function init() {
    document.addEventListener('submit', handleSubmit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
